import { jsx as _jsx } from "react/jsx-runtime";
export const HorizontalRuleJSXConverter = {
  horizontalrule: /*#__PURE__*/_jsx("hr", {})
};
//# sourceMappingURL=horizontalRule.js.map